import { FLOWTYPE_SHO_MIGRATED } from 'aa/vue/constants/shared';
import { FLOW_TYPE } from 'models/FlowModel';

export const USER_REG_TYPE = Object.freeze({
    CBS_SPORTS: 'cbssports_rendezvous',
    EDU: 'student',
    GIFT: 'gift',
    LIVE_TV: 'mvpd',
    RENDEZVOUS: 'rendezvous',
    STANDARD: 'standard',
    MVPD: 'mvpd',
});

export const userRegTypesForFlow = {
    [FLOW_TYPE.CBS_SPORTS]: USER_REG_TYPE.CBS_SPORTS,
    [FLOW_TYPE.EDU]: USER_REG_TYPE.EDU,
    [FLOW_TYPE.GIFT]: USER_REG_TYPE.GIFT,
    [FLOW_TYPE.LIVE_TV]: USER_REG_TYPE.LIVE_TV,
    [FLOWTYPE_SHO_MIGRATED]: 'showtime',
};

export const PAGE_TYPES = Object.freeze({
    ACCOUNT: 'account',
    ACCOUNT_SWITCH_PAYMENT: 'account_switchpayment',
    ACTIVATION_CONSENT: 'activation_consent',
    ACTIVATION_PAGE: 'rendezvous_activation_enter_code',
    BIND_FAILURE: 'svod_bindingFailure',
    BUNDLE_INTERSTITIAL: 'upsell_partner_bundle',
    COMPLETE_PAGE: 'rendezvous_activation_complete',
    CONFIRMATION_NO_ACCOUNT: 'tv-provider_nolinkaccount',
    DIRECT_LINK_PAYMENT_SIGN_IN: 'winback_si_directLink_payment',
    DIRECT_LINK_PAYMENT_SIGN_UP: 'winback_su_directLink_payment',
    EDU: 'svod_edu',
    EXPLAINER_PAGE: 'rendezvous_explainer',
    EXSUB_PAYMENT: 'exsub_payment',
    LOGIN_OPTIONS: 'rendezvous_activation_signin',
    PAYMENT: 'svod_payment',
    PAYMENT_COMPLETE: 'svod_complete',
    PICK_A_PLAN_BUNDLE: 'svod_pick_bundle_plan',
    PICK_A_PLAN_DEFAULT: 'svod_pickaplan',
    PPLUS_NO_ACCESS: 'account_subscription-error',
    PROVIDER_ACTIVATION_FAIL: 'svod_provider_activationfail',
    RENDEZVOUS_SIGNIN_COMPLETE: 'tv-provider_connect-complete',
    SIGNIN: 'svod_signin',
    SIGNIN_SHO_MIGRATED: 'sho_signin',
    SIGNUP: 'svod_signup',
    SIGNUP_COMPLETE: 'svod_signup_complete',
    TV_PROVIDER_SELECTION_SCREEN: 'tv-provider_select',
});

export const ACTION_NAMES = Object.freeze({
    BIND_SUCCESS: 'oAuthTrackPaymentComplete',
    TV_PROVIDER_TRACK_ACCOUNT_MANAGEMENT: 'trackManageSubscriptionButtonClick',
    TV_PROVIDER_SELECTION: 'trackTvProviderSelection',
    TV_PROVIDER_MORE_SELECTION: 'trackMoreTvProviderSelection',
    MVPD_ACCOUNT_BINDING_SUCCESS: 'trackMVPDAccountBindingSuccess',
    MVPD_ACCOUNT_DISCONNECT_COMPLETE: 'trackManualMVPDDisconnectComplete',
    MVPD_LOGIN_CTA: 'trackLoginCTA',
    MVPD_CREATE_ACCOUNT_CTA: 'trackCreateAccountCTA',
    SIGNIN_MVPD_PROVIDER_CTA: 'trackSignInTvProvider',
    PAYMENT_ANNUAL_PLAN_TOGGLE: 'trackPaymentAnnualPlanToggle',
    SELECT_NEW_BILLING_CADENCE: 'trackSelectNewBillingCadence',
    FTC_CHECKBOX_DESELECT: 'trackFTCCheckboxDeselect',
    FTC_CHECKBOX_SHOWN: 'trackFTCCheckbox',
    TRACK_APP_REDIRECT: 'trackAppRedirect',
});

export const SUBSCRIBER_FLAG = Object.freeze({
    EX_SUBSCRIBER: 'Ex Subscriber',
    NEW_SUBSCRIBER: 'New Subscriber',
});

export const AUTH_PARTNER_IDS = Object.freeze({
    CBS_SPORTS: 'cbssports',
    NFL: 'nfl',
});
